import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

const NewDesignConfirmationDialog = ({ open, onClose, onConfirm, action }) => {
  const isTrashAction = action === "trash";
  const dialogTitle = isTrashAction
    ? "Remove To Trash"
    : "New Design Confirmation";
  const dialogText = isTrashAction
    ? "All the objects in your canvas will be removed and its history deleted. Are you sure?"
    : "All the objects in your canvas will be removed and its history deleted. Are you sure?";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="new-design-dialog-title"
      aria-describedby="new-design-dialog-description"
    >
      <DialogTitle id="new-design-dialog-title">{dialogTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText id="new-design-dialog-description">
          {dialogText}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} color="primary" autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewDesignConfirmationDialog;
